import { useState, useEffect } from "react"
import { useLocalization } from "@tm/localization"
import { CurrencyField, Icon, IconButton, PercentageField } from "@tm/components"
import { Controller, useFormContext } from "react-hook-form"
import { errorHandling } from "@tm/utils"
import { ValueLabelStack } from "../../../../../ValueLabelStack"

type Props = {
    currencyCode: string
}

export function PartPriceFields({ currencyCode }: Props) {
    const { translateText } = useLocalization()
    const [originalPricesExpanded, setOriginalPricesExpanded] = useState<boolean>(true)
    const { control, watch, setValue } = useFormContext()

    const regularPrice = Number(watch("regularPrice"))
    const surcharge = Number(watch("surcharge"))
    const regularPriceWithSurcharge = Number(watch("regularPriceWithSurcharge"))
    const rebate = Number(watch("rebate"))
    const offerPrice = Number(watch("offerPrice"))

    useEffect(() => {
        if (!regularPrice) {
            setValue("regularPrice", 0)
        }
        if (!surcharge) {
            setValue("surcharge", 0)
        }
        if (!rebate) {
            setValue("rebate", 0)
        }
        const priceWithSurcharge = (regularPrice ?? 0) + (regularPrice ?? 0) * ((surcharge ?? 0) / 100)
        setValue("regularPriceWithSurcharge", priceWithSurcharge)
        const price = priceWithSurcharge - priceWithSurcharge * ((rebate ?? 0) / 100)
        setValue("offerPrice", price)
    }, [rebate, regularPrice, surcharge])

    return (
        <>
            {originalPricesExpanded && (
                <>
                    <Controller
                        control={control}
                        name="regularPrice"
                        render={({ field, fieldState }) => (
                            <CurrencyField
                                label={`${translateText(53)} ${currencyCode}`}
                                size="extralarge"
                                max={9999999}
                                sx={{ width: "140px" }}
                                {...field}
                                {...errorHandling(fieldState)}
                            />
                        )}
                    />
                    <Controller
                        control={control}
                        name="surcharge"
                        render={({ field, fieldState }) => (
                            <PercentageField
                                label={`${translateText(12475)} %`}
                                max={9999}
                                size="extralarge"
                                sx={{ width: "105px" }}
                                {...field}
                                {...errorHandling(fieldState)}
                            />
                        )}
                    />
                    <ValueLabelStack label={`${translateText(57)} ${currencyCode}`} value={regularPriceWithSurcharge} />
                </>
            )}
            <IconButton onClick={() => setOriginalPricesExpanded(!originalPricesExpanded)} size="large">
                <Icon name={originalPricesExpanded ? "arrow-right" : "arrow-left"} />
            </IconButton>
            <Controller
                control={control}
                name="rebate"
                render={({ field, fieldState }) => (
                    <PercentageField
                        label={`${translateText(54)} %`}
                        size="extralarge"
                        sx={{ width: "105px" }}
                        {...field}
                        {...errorHandling(fieldState)}
                    />
                )}
            />
            <ValueLabelStack label={`${translateText(57)} ${currencyCode}`} value={offerPrice} />
        </>
    )
}
